import { LOAD_ANNOUNCEMENTS, UPDATE_ANNOUNCEMENTS } from '../actionTypes';
import { loadReducer } from './helpers';

export const announcements = (state = null, action) => {
  switch (action.type) {
    case LOAD_ANNOUNCEMENTS: {
      return loadReducer(state, action);
    }
    case UPDATE_ANNOUNCEMENTS: {
      return {
        data: [
          ...(state && state.data ? state.data : []),
          ...action.payload.data,
        ],
      };
    }

    default:
      return state;
  }
};
